import * as React from 'react';
import FormItem from 'antd/lib/form/FormItem';
import Input from 'antd/lib/input';
import { VERSION_REGEX } from '../../utils/hooks/useVersionValidation';

export interface ReleaseVersionFormItemProps {
    disabled?: boolean;
    hidden?: boolean;
    labelCol?: { flex: string };
    helpText?: string | null;
    onValidate: (version: string) => Promise<void>;
}

export const ReleaseVersionFormItem: React.FC<ReleaseVersionFormItemProps> = ({
    disabled = false,
    hidden = false,
    labelCol = { flex: '130px' },
    helpText,
    onValidate,
}) => {
    const validateVersion = async (_rule: unknown, version: string): Promise<void> => {
        if (!version || !VERSION_REGEX.test(version)) {
            return Promise.reject('Version must contain only numbers and up to 3 segments');
        }

        return onValidate(version);
    };

    return (
        <FormItem
            label="Release version"
            name="releaseVersion"
            rules={[
                {
                    validator: validateVersion,
                },
                {
                    required: true,
                    message: 'Version is required',
                },
            ]}
            hidden={hidden}
            help={helpText}
            labelCol={labelCol}
        >
            <Input style={{ fontSize: 18 }} disabled={disabled} autoComplete="off" />
        </FormItem>
    );
};
